import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type DocumentFileIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const DocumentFileIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.gray.light350,
  ...props
}: DocumentFileIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44267 2.776L7.55733 0.890667C7.30733 0.640667 6.968 0.5 6.61467 0.5H1.83333C1.09667 0.5 0.5 1.09667 0.5 1.83333V11.1667C0.5 11.9033 1.09667 12.5 1.83333 12.5H8.5C9.23667 12.5 9.83333 11.9033 9.83333 11.1667V3.71867C9.83333 3.36533 9.69267 3.026 9.44267 2.776V2.776Z"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83333 3.83333H7.16667C6.79867 3.83333 6.5 3.53467 6.5 3.16667V0.5"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.05859 9.53328H6.27193"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.38867 7.00059V6.22192C4.38867 6.00725 4.56267 5.83325 4.77734 5.83325H5.55601C5.77067 5.83325 5.94467 6.00725 5.94467 6.22192V7.00059C5.94467 7.21525 5.77067 7.38925 5.55601 7.38925H4.77734C4.56267 7.38859 4.38867 7.21459 4.38867 7.00059Z"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 10.1114V9.33276C2.5 9.11809 2.674 8.94409 2.88867 8.94409H3.66733C3.882 8.94409 4.056 9.11809 4.056 9.33276V10.1114C4.056 10.3261 3.882 10.5001 3.66733 10.5001H2.88867C2.674 10.5001 2.5 10.3261 2.5 10.1114Z"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.27734 10.1114V9.33276C6.27734 9.11809 6.45134 8.94409 6.66601 8.94409H7.44468C7.65934 8.94409 7.83334 9.11809 7.83334 9.33276V10.1114C7.83268 10.3261 7.65868 10.5001 7.44401 10.5001H6.66534C6.45134 10.5001 6.27734 10.3261 6.27734 10.1114H6.27734Z"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.65901 8.94662L5.65234 7.37329"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.67188 8.94662L4.67854 7.37329"
        stroke={color}
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
